import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export const arkFoodsQcInspectionFileDataSchema = yup.object({
  receivingDate: yup.string().notRequired(),
  shipmentBolNumber: yup.string().notRequired(),
  receivingLocation: yup.string().notRequired(),
  vendorName: yup.string().notRequired(),
  plantingNumber: yup.string().notRequired(),
  poNumber: yup.string().notRequired(),
  sku: yup.string().notRequired(),
  totalQuantityBoxes: yup.string().notRequired(),
  actualWeightPerBoxLb: yup.string().notRequired(),
  actualCountPerBox: yup.string().notRequired(),
  truckTempF: yup.string().notRequired(),
  pulpTempF: yup.string().notRequired(),
  discolorationSunburn: yup.string().notRequired(),
  small: yup.string().notRequired(),
  blossomEndRot: yup.string().notRequired(),
  crackScarring: yup.string().notRequired(),
  softShriveling: yup.string().notRequired(),
  stemless: yup.string().notRequired(),
  mechanicalDamage: yup.string().notRequired(),
  pittingBruising: yup.string().notRequired(),
  other: yup.string().notRequired(),
  otherDescription: yup.string().notRequired(),
  comments: yup.string().notRequired(),
  organizationLogoOverride: yup.string().notRequired(),
})

export type ArkFoodsQcInspectionFileData = yup.InferType<typeof arkFoodsQcInspectionFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<ArkFoodsQcInspectionFileData>

export const arkFoodsQcInspectionFileMappings: RequiredFileData = {
  receivingDate: '42c69c5f-ee45-4fbd-b005-0e6ca2bb69f4',
  shipmentBolNumber: '82d982c9-891d-47ef-a544-7f51e367d268',
  receivingLocation: '8ef77778-1038-4d1d-ba9e-7904480d0cc4',
  vendorName: 'de292e9b-18d0-4262-b6c8-1b1466574c70',
  plantingNumber: '36fd571a-d4bf-417b-9da2-f7e632405742',
  poNumber: '02467238-ecdf-4085-bf0b-5e1ec6873691',
  sku: '30c3110d-be53-44c5-a246-17f0ae1a91c1',
  totalQuantityBoxes: '4728ae70-cb21-48a8-9af1-5af5b07b35c1',
  actualWeightPerBoxLb: 'd90cde29-6d48-4491-9f6d-c34b61d873b6',
  actualCountPerBox: 'dc1d8250-d3c3-4e61-93a5-b32ae4bca6d0',
  truckTempF: '3c246b34-06a8-4806-8ea4-a8aa2dad601f',
  pulpTempF: '7c71d407-013d-4089-9f4e-19500675d2f2',
  discolorationSunburn: '86d764ee-541f-4021-a24e-0349b730a3eb',
  small: '7ba3e534-5f16-4674-92eb-5eafefd36014',
  blossomEndRot: '7dd15b3f-0351-4278-af47-e1f049f5a67d',
  crackScarring: '67e8f202-8b10-431f-9c9a-8f1eb4a2e4a6',
  softShriveling: '9dc2aea3-b96e-4c7b-a14c-547768a88d8b',
  stemless: '97f8d1f1-13b5-4f36-938c-c8f9876d8e91',
  mechanicalDamage: 'b14d4300-d830-492f-b2c4-959c9cc52f40',
  pittingBruising: '3a6969e0-060a-42bf-b0ca-20caea6378bd',
  other: '0d221e35-cf76-4e4e-a60a-fcd0c2dab64f',
  otherDescription: '945ccd01-9df5-4760-af65-ed5d199db433',
  comments: 'bff2ff18-0602-4ab8-bf49-00fda31d0131',
  organizationLogoOverride: '63fb737b-5ec0-4b0c-95b3-71c8c261d23f',
}
